// Physiological ranges used to flag abnormal adult vitals.
// Values outside [min, max] produce a "high" / "low" flag.
export const VITAL_RANGES = {
  systolic:         { min: 90,  max: 180, unit: "mmHg", label: "BP sys" },
  diastolic:        { min: 60,  max: 110, unit: "mmHg", label: "BP dia" },
  pulse:            { min: 50,  max: 120, unit: "bpm",  label: "Pulse" },
  temperature:      { min: 35,  max: 38.5,unit: "°C",   label: "Temp" },
  respiratory_rate: { min: 12,  max: 25,  unit: "/min", label: "RR" },
  spo2:             { min: 92,  max: 100, unit: "%",    label: "SpO₂" },
  glucose:          { min: 3.9, max: 11.0,unit: "mmol/L",label: "Glu" },
};

/** Returns { flags: {key: 'low'|'high'}, hasAlert, labels: ['SpO₂ 88% (low)', ...] } */
export function vitalAlerts(v) {
  if (!v) return { flags: {}, hasAlert: false, labels: [] };
  const flags = {};
  const labels = [];
  Object.entries(VITAL_RANGES).forEach(([key, r]) => {
    const val = v[key];
    if (val === null || val === undefined || val === "") return;
    const n = Number(val);
    if (Number.isNaN(n)) return;
    if (n < r.min) { flags[key] = "low"; labels.push(`${r.label} ${n}${r.unit} (low)`); }
    else if (n > r.max) { flags[key] = "high"; labels.push(`${r.label} ${n}${r.unit} (high)`); }
  });
  return { flags, hasAlert: labels.length > 0, labels };
}

/** Hours since ISO timestamp; returns null if invalid. */
export function hoursSince(iso) {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (!t) return null;
  return (Date.now() - t) / 3600000;
}

/** Human-readable "N h M m ago" from ISO. */
export function humanAgo(iso) {
  const h = hoursSince(iso);
  if (h == null) return "—";
  if (h < 1) return `${Math.max(0, Math.floor(h * 60))}m ago`;
  const wholeH = Math.floor(h);
  const rem = Math.round((h - wholeH) * 60);
  if (wholeH < 24) return rem > 0 ? `${wholeH}h ${rem}m ago` : `${wholeH}h ago`;
  const d = Math.floor(wholeH / 24);
  return `${d}d ago`;
}
